import React from 'react';

export default React.createContext({
  portfolio: null,
  isPortfolioLoading: null,
  isGeneralLoading: null,
});
